import { Blok } from '../../interfaces/Blok.interface';

export const getHeroBloksFromBody = (body: Blok[]): Blok[] => {
  const HERO_COMPONENTS: string[] = [
    'homepage_hero',
    'page_hero_variant_one',
    'page_hero_variant_two',
    'page_hero_variant_three',
    'article_hero',
    'page_not_found_hero',
    'author_hero',
  ];
  return body?.filter((blok: Blok) => HERO_COMPONENTS.includes(blok.component));
};
